import { ERequestType } from "../../Enum/ERequestType"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { tutorialMemory } from "../../Objects/Memory/Memory"
import { TutorialEntity } from "../../Objects/Tutorial/TutorialEntity"
import { GetRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"
import { ETutorialAudienceType } from "../../Enum/ETutorialAudienceType"

export const useGetTutorial = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetTutorial = async (
    onSuccess: () => void,
    route: string = API_ROUTES.TUTORIAL.GET_ALL,
    audience: ETutorialAudienceType = ETutorialAudienceType.Store,
  ) => {
    enableLoad()

    try {
      const response = await GetRequest<TutorialEntity[]>(`${route}?audience=${audience}`)

      if (!response.success) {
        throw new Error(response.message)
      }

      tutorialMemory.setList((response.data ?? []).map((item) => new TutorialEntity(item)))

      onSuccess()
    } catch (e) {
      const message = e instanceof Error ? e.message : "Erro ao buscar tutoriais."

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleGetTutorialAdmin = async (onSuccess: (data: TutorialEntity[]) => void) => {
    enableLoad()

    try {
      const response = await GetRequest<TutorialEntity[]>(API_ROUTES.ADMIN_TUTORIAL.GET_ALL, ERequestType.Admin)

      if (!response.success) {
        throw new Error(response.message)
      }

      const list = (response.data ?? []).map((item) => new TutorialEntity(item))

      onSuccess(list)
    } catch (e) {
      const message = e instanceof Error ? e.message : "Erro ao buscar tutoriais."

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleGetTutorial, handleGetTutorialAdmin }
}
